import { useEffect, useState } from 'react'

export default (elementId, defaultElementId = null, extraHeight = 0) => {
  const [height, setHeight] = useState(0)

  useEffect(() => {
    let obs = null
    if (elementId) {
      obs = new MutationObserver(() => {
        const element = document.getElementById(elementId) ? document.getElementById(elementId) : document.getElementById(defaultElementId)
        setHeight(element ? element.scrollHeight + extraHeight : 0)
      })

      const element = defaultElementId ? document.getElementById(defaultElementId) : document.getElementById(elementId)
      obs.observe(element, { childList: true, subtree: true })
    }
    return () => {
      obs && obs.disconnect()
    }
  }, [elementId, setHeight, height, defaultElementId, extraHeight])
  return [height]
}
